import { compose, branch } from 'recompose';

import { withLogger, getExtendedLogger } from '@mindtickle/ui-shell-core/Logger';

import logger from '~/config/app.logger';

import { withTranslationsInternal } from '~/components/Intl';
import { withRelay } from '~/components/Relay';
import { withSnowPlow } from '~/components/Snowplow';
import { withRedux } from '~/components/Redux';
import { LOGGER_NAME } from '../constants';

import type { TComponentRendererProps } from '../types';

const validator = (condition: boolean, hocsType: string) => () => {
  if (condition) return true;
  const log = getExtendedLogger(LOGGER_NAME, logger);

  log(`skipping ${hocsType}`);
  return false;
};

const withComponentRenderer = <P extends {}>({
  streamName,
  appName,
  graphqlEndpoint,
  enableSubscription,
  graphqlEndpoints, //[Todo] Deprecated
  collectorUrl,
  enableRedux,
  environmentOptions,
}: TComponentRendererProps) => {
  if (!(streamName && appName))
    throw new Error('Missing parameters: streamName & appName are required');

  graphqlEndpoint = graphqlEndpoint || graphqlEndpoints?.[0];

  return compose<P, P>(
    withLogger<P>({ namespace: `${streamName}-${appName}` }),
    withTranslationsInternal<P>({ appName }),
    branch(validator(!!enableRedux, 'redux'), withRedux<P>()),
    branch(
      validator(!!graphqlEndpoint, 'relay'),
      withRelay<P>({
        enableSubscription: !!enableSubscription,
        graphqlEndpoint: graphqlEndpoint!,
        environmentOptions,
      })
    ),
    branch(
      validator(!!collectorUrl, 'snowplow'),
      withSnowPlow<P>({
        collectorUrl: collectorUrl!,
        namespace: `${streamName}-${appName}`,
      })
    )
  );
};

export default withComponentRenderer;
